// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"da425f51","271":"a4fe211c"}[chunkId] + ".chunk.css";
};